/* Custom slide-out cart drawer — standalone, independent of Debutify/UpCart.
   Intercepts add-to-cart submits in the capture phase so Debutify's native
   bubble-phase handler (which redirects to /cart) never runs. */
(function () {
  "use strict";

  var ROOT_ID = "CustomCartDrawer";
  var root, panel, overlay, itemsEl, subtotalEl, footerEl, emptyEl, shipBarEl, discountsEl, totalRowEl, totalValueEl;
  var isOpen = false;
  var busy = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    try {
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        return window.theme.Currency.formatMoney(cents, window.theme.strings.moneyFormat);
      }
    } catch (e) {}
    return "€" + (cents / 100).toFixed(2).replace(".", ",");
  }

  function cache() {
    root = document.getElementById(ROOT_ID);
    if (!root) return false;
    panel = $(".ccd__panel", root);
    overlay = $(".ccd__overlay", root);
    itemsEl = $(".ccd__items", root);
    subtotalEl = $(".ccd__subtotal-value", root);
    footerEl = $(".ccd__footer", root);
    emptyEl = $(".ccd__empty", root);
    shipBarEl = $(".ccd__shipbar", root);
    discountsEl = $(".ccd__discounts", root);
    totalRowEl = $(".ccd__row--total", root);
    totalValueEl = $(".ccd__total-value", root);
    return true;
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? "hidden" : "";
    document.body.style.overflow = lock ? "hidden" : "";
  }

  function open() {
    if (!root) return;
    isOpen = true;
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    lockScroll(true);
  }

  function close() {
    if (!root) return;
    isOpen = false;
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    lockScroll(false);
  }

  function updateCount(count) {
    $all(".cart-count").forEach(function (el) { el.textContent = count; });
    $all(".cart-link__bubble").forEach(function (el) {
      el.classList.toggle("cart-link__bubble--visible", count > 0);
    });
  }

  // Volume-discount tiers (per product, by total quantity of that product in the
  // cart). HulkApps never writes the discount into the Shopify cart — it recomputes
  // it server-side at checkout — so the drawer mirrors the same tiers here purely for
  // display. The actual discount is applied by hulkappsCheckout() at checkout.
  // Thresholds/percentages must match the HulkApps offer. Rounding = floor (matches
  // HulkApps, e.g. 5% of 14950 = 747.5 → 747 cents).
  var VOLUME_TIERS = [
    { min: 10, pct: 0.10 },
    { min: 5, pct: 0.05 },
    { min: 3, pct: 0.03 }
  ];

  function tierPct(qty) {
    for (var i = 0; i < VOLUME_TIERS.length; i++) {
      if (qty >= VOLUME_TIERS[i].min) return VOLUME_TIERS[i].pct;
    }
    return 0;
  }

  // Returns { byKey: {key: discountCents}, total: cents }. Quantity is summed per
  // product_id so multiple variants of the same product count toward one tier.
  function computeDiscounts(cart) {
    var qtyByProduct = {};
    (cart.items || []).forEach(function (it) {
      qtyByProduct[it.product_id] = (qtyByProduct[it.product_id] || 0) + it.quantity;
    });
    var byKey = {}, total = 0;
    (cart.items || []).forEach(function (it) {
      var pct = tierPct(qtyByProduct[it.product_id]);
      var cents = pct ? Math.floor(it.original_line_price * pct) : 0;
      byKey[it.key] = cents;
      total += cents;
    });
    return { byKey: byKey, total: total };
  }

  function priceHTML(item, discount) {
    if (discount > 0) {
      var discounted = item.original_line_price - discount;
      return (
        '<div class="ccd__item-price">' +
          '<span class="ccd__price-orig">' + money(item.original_line_price) + '</span>' +
          '<span class="ccd__price-final">' + money(discounted) + '</span>' +
          '<span class="ccd__line-saved">&minus;' + money(discount) + '</span>' +
        '</div>'
      );
    }
    return '<div class="ccd__item-price">' + money(item.original_line_price) + '</div>';
  }

  function lineItemHTML(item, discount) {
    var variant = (item.variant_title && item.variant_title !== "Default Title") ? item.variant_title : "";
    var img = item.image
      ? '<img class="ccd__img" src="' + item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, "_120x$1$2") + '" alt="" loading="lazy">'
      : '<div class="ccd__img ccd__img--placeholder"></div>';
    return (
      '<li class="ccd__item" data-key="' + item.key + '">' +
        '<a class="ccd__item-media" href="' + item.url + '">' + img + '</a>' +
        '<div class="ccd__item-body">' +
          '<a class="ccd__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
          (variant ? '<div class="ccd__item-variant">' + variant + '</div>' : '') +
          '<div class="ccd__item-bottom">' +
            '<div class="ccd__qty">' +
              '<button type="button" class="ccd__qty-btn" data-ccd-dec aria-label="Menge verringern">&minus;</button>' +
              '<span class="ccd__qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="ccd__qty-btn" data-ccd-inc aria-label="Menge erhöhen">&plus;</button>' +
            '</div>' +
            priceHTML(item, discount) +
          '</div>' +
        '</div>' +
        '<button type="button" class="ccd__remove" data-ccd-remove aria-label="Entfernen">&times;</button>' +
      '</li>'
    );
  }

  function renderShipBar(cart) {
    if (!shipBarEl) return;
    var threshold = parseInt(root.getAttribute("data-free-shipping-threshold") || "0", 10);
    if (!threshold || threshold <= 0) { shipBarEl.style.display = "none"; return; }
    shipBarEl.style.display = "";
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    var msg = remaining > 0
      ? 'Nur noch <strong>' + money(remaining) + '</strong> bis zum <strong>Gratisversand</strong>!'
      : '🎉 Du erhältst <strong>Gratisversand</strong>!';
    shipBarEl.innerHTML =
      '<div class="ccd__shipbar-msg">' + msg + '</div>' +
      '<div class="ccd__shipbar-track"><div class="ccd__shipbar-fill" style="width:' + pct + '%"></div></div>';
  }

  function renderDiscounts(cart, totalDiscount) {
    if (!discountsEl) return;
    if (totalDiscount > 0) {
      discountsEl.innerHTML =
        '<div class="ccd__row ccd__row--discount"><span>Mengenrabatt</span>' +
        '<span class="ccd__discount-amount">&minus;' + money(totalDiscount) + '</span></div>';
    } else {
      discountsEl.innerHTML = "";
    }
    var hasDiscount = totalDiscount > 0;
    if (totalRowEl) totalRowEl.style.display = hasDiscount ? "" : "none";
    if (hasDiscount && totalValueEl) {
      totalValueEl.textContent = money(cart.items_subtotal_price - totalDiscount);
    }
  }

  function render(cart) {
    updateCount(cart.item_count);
    renderShipBar(cart);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = "";
      if (discountsEl) discountsEl.innerHTML = "";
      if (totalRowEl) totalRowEl.style.display = "none";
      if (emptyEl) emptyEl.style.display = "";
      if (footerEl) footerEl.style.display = "none";
      return;
    }
    if (emptyEl) emptyEl.style.display = "none";
    if (footerEl) footerEl.style.display = "";
    var disc = computeDiscounts(cart);
    itemsEl.innerHTML = cart.items.map(function (item) {
      return lineItemHTML(item, disc.byKey[item.key] || 0);
    }).join("");
    if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price);
    renderDiscounts(cart, disc.total);
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetchCart().then(render);
  }

  function setBusy(b) {
    busy = b;
    if (root) root.classList.toggle("is-busy", b);
  }

  function changeQty(key, qty) {
    if (busy) return;
    setBusy(true);
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { return refresh(); })
      .finally(function () { setBusy(false); });
  }

  function addFromForm(form) {
    if (busy) return;
    setBusy(true);
    var btn = form.querySelector('[name="add"]');
    if (btn) btn.classList.add("is-loading");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || "Artikel konnte nicht hinzugefügt werden.";
        window.alert(msg);
      })
      .finally(function () {
        if (btn) btn.classList.remove("is-loading");
        setBusy(false);
      });
  }

  function isAddToCartForm(form) {
    return form && form.tagName === "FORM" && /\/cart\/add/.test(form.getAttribute("action") || "");
  }

  function bind() {
    // Capture-phase: run before Debutify's bubble-phase submit handler.
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!isAddToCartForm(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addFromForm(form);
    }, true);

    // Cart icon → open drawer (capture, to beat any leftover bindings).
    document.addEventListener("click", function (e) {
      var link = e.target.closest && e.target.closest(".cart-link");
      if (!link) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      refresh();
    }, true);

    // Drawer interactions (delegated, normal phase).
    root.addEventListener("click", function (e) {
      var t = e.target;
      if (t.closest("[data-ccd-close]") || t === overlay) { close(); return; }
      // Checkout → route through HulkApps so the volume discount is applied at
      // checkout. hulkappsCheckout(null) recomputes the discount server-side from the
      // live cart, so it stays correct after qty edits in the drawer. Falls back to a
      // plain /checkout navigation if HulkApps isn't present.
      if (t.closest(".ccd__checkout")) {
        if (typeof window.hulkappsCheckout === "function") {
          e.preventDefault();
          window.hulkappsCheckout(null);
        }
        return;
      }
      var li = t.closest && t.closest(".ccd__item");
      if (!li) return;
      var key = li.getAttribute("data-key");
      var qtyEl = $(".ccd__qty-val", li);
      var current = parseInt(qtyEl ? qtyEl.textContent : "1", 10) || 1;
      if (t.closest("[data-ccd-remove]")) { changeQty(key, 0); }
      else if (t.closest("[data-ccd-inc]")) { changeQty(key, current + 1); }
      else if (t.closest("[data-ccd-dec]")) { changeQty(key, Math.max(0, current - 1)); }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen) close();
    });
  }

  function init() {
    if (!cache()) return;
    bind();
    refresh();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.CustomCartDrawer = { open: function () { open(); refresh(); }, close: close, refresh: refresh };
})();
